import{isFunction as f}from"@aws-amplify/ui";const o="undefined"!=typeof Symbol&&f(Symbol.for)?Symbol.for("amplify_default"):"@@amplify_default";export{o as AMPLIFY_SYMBOL};
